// src/utils/alert.ts
import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type AlertType = 'info' | 'success' | 'error' | 'warning';

export const showAlert = (message: string, type: AlertType = 'info', options?: ToastOptions) => {
    const defaultOptions: ToastOptions = {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
    };

    switch (type) {
        case 'success':
            toast.success(message, defaultOptions);
            break;
        case 'error':
            toast.error(message, defaultOptions);
            break;
        case 'warning':
            toast.warning(message, defaultOptions);
            break;
        default:
            toast.info(message, defaultOptions);
    }
};